<!--<div>-->
<!--  <div >-->
<!--    <mat-spinner style="width: 60px;height: 60px" strokeWidth="3"  mode="indeterminate" [diameter]="60"></mat-spinner>-->
<!--    <div>{{data}}</div>-->
<!--  </div>-->
<!--</div>-->

<!--<mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>-->


<div>
  <div>{{ data }}</div>
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
</div>
